const renderSuccess = (form) => {
  const message = document.createElement('p');
  message.className = 'colet-newsletter__success';
  message.setAttribute('role', 'status');
  message.textContent = form.dataset.newsletterSuccess;
  form.replaceChildren(message);
};

const renderError = (form) => {
  let message = form.querySelector('.colet-newsletter__message');
  if (!message) {
    message = document.createElement('div');
    message.className = 'colet-newsletter__message';
    message.setAttribute('role', 'alert');
    form.querySelector('.colet-newsletter__field').after(message);
  }
  message.textContent = form.closest('.colet-footer').dataset.newsletterError;
  message.hidden = false;
};

const submitNewsletter = async (event) => {
  const form = event.currentTarget;
  if (!(form instanceof HTMLFormElement)) return;
  event.preventDefault();
  if (form.getAttribute('aria-busy') === 'true') return;

  const emailInput = form.querySelector('input[type="email"]');
  if (!emailInput) return;
  emailInput.value = emailInput.value.trim().toLowerCase();
  if (!form.reportValidity()) return;

  const submitButton = form.querySelector('button[type="submit"]');
  const formStyle = window.getComputedStyle(form);
  const outsideContent = formStyle.boxSizing === 'border-box' ? 0 :
    ['paddingTop', 'paddingBottom', 'borderTopWidth', 'borderBottomWidth']
      .reduce((total, property) => total + (parseFloat(formStyle[property]) || 0), 0);
  form.style.minHeight = `${form.getBoundingClientRect().height - outsideContent}px`;
  const message = form.querySelector('.colet-newsletter__message');
  if (message) message.hidden = true;
  form.setAttribute('aria-busy', 'true');
  emailInput.disabled = true;
  if (submitButton) submitButton.disabled = true;

  try {
    const companyId = form.dataset.klaviyoCompanyId;
    const listId = form.dataset.klaviyoNewsletterListId;
    if (!companyId || !listId) throw new Error('Newsletter configuration missing.');
    const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: {'Content-Type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: '2026-07-15'},
      body: JSON.stringify({data: {type: 'subscription',
        attributes: {
          custom_source: 'Footer newsletter signup',
          profile: {data: {type: 'profile', attributes: {email: emailInput.value,
            subscriptions: {email: {marketing: {consent: 'SUBSCRIBED'}}}
          }}}
        },
        relationships: {list: {data: {type: 'list', id: listId}}}
      }}),
      signal: AbortSignal.timeout(20000),
    });
    if (!response.ok) throw new Error('Newsletter request failed.');
    renderSuccess(form);
  } catch {
    renderError(form);
  } finally {
    form.removeAttribute('aria-busy');
    emailInput.disabled = false;
    if (submitButton) submitButton.disabled = false;
  }
};

document.querySelectorAll('.colet-footer .colet-newsletter__form').forEach((form) => {
  form.addEventListener('submit', submitNewsletter);
  const submitButton = form.querySelector('button[type="submit"]');
  if (submitButton) submitButton.disabled = false;
});
